import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../utils/misc';
import IconPlus from './Icon/IconPlus';

interface FloatingActionButtonProps {
    onClick: () => void;
    className?: string;
    labelKey?: string;
}

const FloatingActionButton = ({ onClick, className, labelKey = 'quick_add' }: FloatingActionButtonProps) => {
    const { t } = useTranslation();
    const [isHovered, setIsHovered] = useState(false);

    return (
        <button
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={cn(
                'fixed z-40',
                'bottom-[calc(2rem_+_env(safe-area-inset-bottom))] right-[calc(2rem_+_env(safe-area-inset-right))]',
                'flex items-center',
                isHovered && "gap-3",
                'bg-primary hover:bg-primary-dark',
                'text-white font-semibold',
                'rounded-full shadow-lg hover:shadow-xl',
                'transition-all duration-300 ease-in-out',
                'group',
                className
            )}
            style={{
                padding: isHovered ? '16px 24px 16px 20px' : '16px',
            }}
            aria-label={t(labelKey as any)}
        >
            <div className="flex items-center justify-center w-6 h-6">
                <IconPlus className="w-5 h-5 transition-transform duration-300 group-hover:rotate-90" />
            </div>
            <span
                className={cn(
                    'whitespace-nowrap overflow-hidden transition-all duration-300',
                    isHovered ? 'max-w-[200px] opacity-100' : 'max-w-0 opacity-0'
                )}
            >
                {t(labelKey as any)}
            </span>
        </button>
    );
};

export default FloatingActionButton;
